export default "__VITE_ASSET__K7FYbO4J__"